import Choices from 'choices.js'

const defaultOptions = {
  removeItemButton: true,
  placeholder: false,
  placeholderValue: '請選擇',
  noResultsText: '查無結果',
  noChoicesText: '無其他選項可選',
  itemSelectText: '',
  uniqueItemText: '僅可增加唯一值',
  loadingText: '載入中...',
  shouldSort: false,
  searchResultLimit: 99,
  maxItemText: (maxItemCount) => {
    return `最多可選擇${maxItemCount}個`
  },
  searchFields: ['label']
}

export function createChoices(element, options = {}) {
  const choicesInstance = new Choices(element, {
    ...defaultOptions,
    ...options
  })
  return choicesInstance
}
